import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackFormStartParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/form/trackFormStart";

const useTrackFormStart = (parameters: TrackFormStartParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.util.getEventTrackerHook(ga.track.formStart, parameters, options);
};

export default useTrackFormStart;
